import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '@vex/http-service/auth.service';

export type LogoutDataChoice = 'keep' | 'clear';

/**
 * Presents the explicit local-data choice for a user-initiated logout.
 * Authentication data is always removed; the choice controls only the shared
 * global platform cache stored in IndexedDB.
 */
@Component({
  selector: 'vex-logout-data-dialog',
  templateUrl: './logout-data-dialog.component.html',
  styleUrls: ['./logout-data-dialog.component.scss']
})
export class LogoutDataDialogComponent {
  isSubmitting = false;
  submittingChoice: LogoutDataChoice | null = null;

  constructor(
    public dialogRef: MatDialogRef<LogoutDataDialogComponent, LogoutDataChoice>,
    private authService: AuthService
  ) {}

  /** Signs out and either retains or clears the shared platform cache. */
  async signOut(clearLocalData: boolean): Promise<void> {
    if (this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;
    this.submittingChoice = clearLocalData ? 'clear' : 'keep';
    try {
      this.authService.isShowExpiryMessage = false;
      await this.authService.logout(false, clearLocalData, true);
      this.dialogRef.close(clearLocalData ? 'clear' : 'keep');
    } catch (error) {
      this.isSubmitting = false;
      this.submittingChoice = null;
      console.error('Unable to sign out.', error);
    }
  }
}
